import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import { MDCTopAppBar } from '@material/top-app-bar';

interface MDCConstructor<TComponent> {
    new(element: Element): TComponent;
}

function initMdcComponent<TComponent>(selector: string, MDCConstructor: MDCConstructor<TComponent>) {
    const elements = document.querySelectorAll(selector);
    for(const element of elements) {
        new MDCConstructor(element);
    }
}
initMdcComponent('.mdc-top-app-bar', MDCTopAppBar);
initMdcComponent('.mdc-button, .mdc-icon-button, .mdc-card__primary-action', MDCRipple);
initMdcComponent('.mdc-text-field', MDCTextField);

document.addEventListener('load', () => {
    const a = document.querySelector<HTMLAnchorElement>("a.PostLogoutRedirectUri");
    if (a) {
        window.location.href = a.href;
    }
});

const redirUrl = document.querySelector<HTMLMetaElement>("meta[http-equiv=refresh]")?.dataset["url"];
if(redirUrl) {
    window.location.href = redirUrl;
}
